import { getCategoryPillTitle } from "@outschool/text";
import { BoxButton } from "@outschool/ui-legacy-component-library";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

import OnlineClassesPageLink from "../OnlineClassesPageLink";
import { TopicInfo } from "./Topics";

type TopicPillProps = {
  children: React.ReactNode;
  isActive?: boolean;
  onClick?: (e: React.SyntheticEvent) => void;
  topicSx?: SystemStyleObject;
};

export const TopicPill: React.FC<TopicPillProps> = ({
  children,
  isActive,
  onClick,
  topicSx,
}) => {
  return (
    <BoxButton
      onClick={onClick}
      sx={{
        padding: "1.1rem",
        border: "1px solid transparent",
        borderRadius: "999px",
        fontSize: "1.6rem",
        maxWidth: "100%",
        height: "auto",
        backgroundColor: "gray100",
        color: "gray900",
        lineHeight: 1.06,
        cursor: "pointer",
        fontWeight: "semibold",
        whiteSpace: "nowrap",
        "&:active": {
          backgroundColor: "peacock300",
          color: "white",
        },
        ...(isActive && {
          backgroundColor: "peacock300",
          color: "white",
        }),
        ...(!isActive && {
          "&:hover": {
            backgroundColor: "peacock50",
            borderColor: "peacock300",
          },
        }),
        ...topicSx,
      }}
    >
      {children}
    </BoxButton>
  );
};

export default function TopicLink({
  topic,
  topicSx,
}: {
  topic: TopicInfo;
  topicSx: SystemStyleObject;
}) {
  const topicTitle = getCategoryPillTitle(topic.title);
  if (topic && topic.hasOwnProperty("slug")) {
    return (
      <OnlineClassesPageLink
        pageSlug={topic.slug}
        pageBasePath={topic.basePath}
        key={topic.title}
      >
        <TopicPill topicSx={topicSx}>{topicTitle}</TopicPill>
      </OnlineClassesPageLink>
    );
  }
  return null;
}
